import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'largeNumeralShortener'
})
export class LargeNumeralShortenerPipe implements PipeTransform {
  shortenerConfig: SuffixValues[] = [
    { suffix: SuffixType.K, exp: 1, rounding: 1 },
    { suffix: SuffixType.M, exp: 2, rounding: 2 },
    { suffix: SuffixType.B, exp: 3, rounding: 2 }
  ];

  transform(value: number, currency?: string): string {
    const sign = Math.sign(value);
    value = Math.abs(value);
    const currencySymbol = currency ? getCurrencySymbol(currency, 'narrow') : '';

      if (value < 100) {
        return currencySymbol + (sign * value).toFixed(2);
      }

      if (value < 1000) {
        return currencySymbol + (sign * value).toFixed(0);
      }

      return currencySymbol + this.getShortenedValue(value, sign);
  }

  getShortenedValue(value: number, sign: number): string {
    const exp: number = Math.floor(Math.log(Math.abs(value)) / Math.log(1000));
    const suffixValue: SuffixValues = this.shortenerConfig.find(x => x.exp === exp);
    const shorteredValue: string = (sign * (Math.abs(value) / Math.pow(1000, exp))).toFixed(suffixValue.rounding) + suffixValue.suffix;
    return shorteredValue;
  }

}

export interface SuffixValues {
  suffix: SuffixType;
  exp: number;
  rounding: number;
}

export enum SuffixType {
  K = 'K',
  M = 'M',
  B = 'B'
}
